const PermissionPathAccessList = ({ pathNames = [], backColor = "" }) => {
  return (
    <div className="w-full flex-1 flex-col align-left justify-start g-05">
      {pathNames.length > 0 &&
        pathNames.map((pathName) => {
          return (
            <div className="w-full flex-row align-center justify-between">
              <div
                className="flex-row align-center justify-center p-05 radius-6 color-white"
                style={{ background: backColor }}
              >
                {pathName}
              </div>
              <div className="toggleBtn">
                <input type="checkbox" />
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default PermissionPathAccessList;
